// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table--selected{background:#eee}.campaign-item .v-list-item{min-height:28px;font-weight:700}.campaign-item .v-list-item .v-icon{margin-right:5px}.campaign-item .v-list-item .v-icon--disabled~span{color:rgba(0,0,0,.38)}.campaign-list .ps{margin-top:0;height:calc(100vh - 90px)}", ""]);
// Exports
module.exports = exports;
